<template>
  <div id="bg-image">
    <otp-verification-page />
  </div>
</template>

<script>
import OtpVerificationPage from '../process/Register/OtpVerificationPage.vue';
    export default {
        name: 'OtpVerification',
        components: {
            OtpVerificationPage,
        },
    };
</script>

<style lang="scss" scoped>

</style>
